import { DocplannerIntegrationMethod } from './DocplannerIntegrationMethod';

export class FacilityIntegration {
  constructor(private readonly method: DocplannerIntegrationMethod) {}

  get isSsoIntegrated(): boolean {
    return this.method === DocplannerIntegrationMethod.sso;
  }
}
